/* PDP clone kit – stats band: once 30% of the band is on screen, each figure counts up from 0 (1 s up to 100,
   1.8 s above, easing out), keeping what comes before and after the number and its thousands separators, like the
   original. A figure that is not a number (a placeholder like XX) stays as it is. Frames run only while counting. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function parse(raw) {
    var m = String(raw || '').trim().match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m) return null;
    var digits = m[2].replace(/,/g, '');
    var dec = digits.indexOf('.') >= 0 ? (digits.split('.')[1] || '').length : 0;
    var target = dec ? parseFloat(digits) : parseInt(digits, 10);
    if (isNaN(target)) return null;
    var sep = m[2].indexOf(',') >= 0;
    var fmt = function (v) {
      var s = dec ? v.toFixed(dec) : String(Math.round(v));
      return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s;
    };
    return { pre: m[1], post: m[3], target: target, fmt: fmt };
  }
  function run(el) {
    var p = parse(el.getAttribute('data-count-to'));
    if (!p) return;
    var dur = p.target <= 100 ? 1000 : 1800, t0 = null;
    var step = function (t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var s = p.pre + p.fmt((1 - (1 - k) * (1 - k)) * p.target) + p.post;
      if (el.textContent !== s) el.textContent = s;   // touch the page only when the figure changes
      if (k < 1) requestAnimationFrame(step);
      else el.textContent = el.getAttribute('data-count-to');
    };
    requestAnimationFrame(step);
  }
  function init(root) {
    (root || document).querySelectorAll('[data-statsband]:not([data-sb-ready])').forEach(function (grid) {
      grid.setAttribute('data-sb-ready', '');
      if (reduce || !('IntersectionObserver' in window)) return;
      // like the original: the figures wait at 0 until the band comes into view (it starts below the fold)
      grid.querySelectorAll('[data-count-to]').forEach(function (el) {
        var p = parse(el.getAttribute('data-count-to'));
        if (p) el.textContent = p.pre + p.fmt(0) + p.post;
      });
      var band = grid.closest('.pdp-statsband') || grid;
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        grid.querySelectorAll('[data-count-to]').forEach(run);
      }, { threshold: 0.3 });
      io.observe(band);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
